import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LogoutIcon from '@mui/icons-material/Logout';
import { Helmet } from 'react-helmet-async';

import config from '@src/config';
import leadGurusLogo from '@src/assets/logo-full-dark.png';
import { fetchClient } from '@src/api/actions/clients';
import { useAuth } from '@src/context';
import AdAccountCardForm from '@src/components/cardVault/AdAccountCardForm';

/**
 * Standalone page for the ad-account card. Linked from the "request" email
 * staff send and from the post-submit onboarding view, so a client can add
 * or replace the card without walking the whole wizard again.
 */
export default function AdAccountCardPage() {
  const { clientSlug } = useParams();
  const { state: authState, logout } = useAuth();
  const [clientName, setClientName] = useState('');

  useEffect(() => {
    if (!clientSlug) return;
    fetchClient(clientSlug)
      .then((res) => setClientName(res?.data?.dba_name || res?.data?.name || ''))
      .catch(() => {});
  }, [clientSlug]);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8f9fa' }}>
      <Helmet><title>Ad Account Card | {config.SITE.title}</title></Helmet>
      <Box sx={{ bgcolor: '#111827', py: 2, px: 3 }}>
        <Container maxWidth="md">
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <img src={leadGurusLogo} alt="Lead Gurus" style={{ height: 28 }} />
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography variant="body2" sx={{ color: '#9ca3af' }}>{authState?.user?.email || clientName}</Typography>
              <Button
                size="small" startIcon={<LogoutIcon />} onClick={logout}
                sx={{ color: '#9ca3af', textTransform: 'none', fontSize: 12, '&:hover': { color: '#fff' } }}
              >
                Logout
              </Button>
            </Stack>
          </Stack>
        </Container>
      </Box>
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Button
          size="small" startIcon={<ArrowBackIcon />} href={`/onboarding/${clientSlug}`}
          sx={{ textTransform: 'none', mb: 2 }}
        >
          Back to onboarding
        </Button>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          {clientName ? `${clientName} — ` : ''}Facebook ad account card
        </Typography>
        <Card variant="outlined">
          <CardContent sx={{ p: 3 }}>
            <AdAccountCardForm clientSlug={clientSlug} />
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
